export const getProductsQuery = `
query($query:String!, $sort: ProductSortKeys, $reverse: Boolean, $after: String){
  products(first: 30, query: $query, sortKey: $sort, after: $after, reverse: $reverse) {
    edges {
      node {
        id
        title
        productType
        handle
        productType
        totalInventory
        tags
        compareAtPriceRange {
          minVariantPrice {
              amount
          }
        }
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        featuredImage {
          altText
          originalSrc
        }
        metafield(key: "excerpt", namespace: "content") {
          id
          value
        }
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
`
